export const RENTER_ORDER_LIST = "RENTER_ORDER_LIST"
export const RENTER_ORDER_LIST_SUCCESSFUL = "RENTER_ORDER_LIST_SUCCESSFUL"
export const RENTER_ORDER_LIST_FAILED = "RENTER_ORDER_LIST_FAILED"